import settings from 'web/utils/settings';
import { isClientSide } from 'web/utils/ssr';

const isStorybook = process.env.STORYBOOK === 'true';

type ErrorReporter = {
  report: (error: Error | string, fatal?: boolean) => void;
  setUser: (userId: string) => void;
};

const consoleReporter = {
  report: console.error,
  setUser: () => {
    // do nothing
  },
};

const getVersion = () => {
  try {
    return process.env.__INTROWISE_VERSION__;
  } catch {
    return 'undefined';
  }
};

const getStackdriverReporter = () => {
  try {
    let savedUser: string | null = null;
    const stub = {
      report: console.error,
      setUser: (userId: string) => {
        savedUser = userId;
      },
    };
    Promise.all([import('stackdriver-errors-js'), import('web/utils/shouldReport')]).then(
      ([{ default: StackdriverErrorReporter }, { filterReports }]) => {
        const stackdriverReporter = new StackdriverErrorReporter();
        filterReports(stackdriverReporter, () => window.navigator.userAgent);
        stackdriverReporter.start({
          key: settings.stackdriver.apiKey,
          projectId: settings.stackdriver.projectId,
          version: getVersion(),
        });
        stackdriverReporter.setUser(savedUser);
        const report = (error: Error | string) => {
          void stackdriverReporter.report(error);
        };
        const setUser = (userId: string) => stackdriverReporter.setUser(userId);
        stub.report = report;
        stub.setUser = setUser;
      },
    );
    return stub;
  } catch (err) {
    console.error(`Failed to setup stackdriver error reporter: `, err);
    return consoleReporter;
  }
};

const errorReporter: ErrorReporter =
  settings.stackdriver.enabled && isClientSide && !isStorybook ? getStackdriverReporter() : consoleReporter;

export default errorReporter;
